import { Component } from 'react'
import PropTypes from 'prop-types'
import InfiniteScroll from 'react-infinite-scroller'
import { inject, observer } from 'mobx-react/index'

import Loading from '../Loading'
import PostPreview from '../PostPreview'
import { Container } from './styles'

@inject('store')
@observer
class PostGridList extends Component {
  static propTypes = {
    posts: PropTypes.arrayOf(Object).isRequired,
    hasMore: PropTypes.bool.isRequired,
    loadMore: PropTypes.func.isRequired
  }

  render() {
    const {
      posts, hasMore, loadMore
    } = this.props

    return (
      <Container>
        <InfiniteScroll
          className="infiniteScroll"
          pageStart={0}
          loadMore={loadMore}
          hasMore={hasMore}
          useWindow={false}
          getScrollParent={() => document.getElementById('sidebarContent')}
          loader={<Loading key={0} />}
        >
          {posts.map(post => (
            <PostPreview key={post.id} post={post} />
          ))}
        </InfiniteScroll>

      </Container>
    )
  }
}

export default PostGridList
